import { useEffect, useState, useMemo } from "react";
import { useSession } from "@clerk/clerk-react";
import { getMyMeetsUpComing as getMyMeetsUpComingApi } from "@/api/meets";
import ActiveMeetingCard from "../cards/active-meets-card";
import { CalendarCheck } from "lucide-react";
import { formatDate } from "@/utils/dates";
import PulledDownWrapper from "../wrappers/pulled-down-wrapper";

const UpComingMeetsComp = () => {
const { session } = useSession();
const [records, setRecord] = useState([]);

useEffect(() => {
    getMyMeetsUpComing()
}, [])

async function getMyMeetsUpComing(){
    const token = await session.getToken();
    getMyMeetsUpComingApi(token).then((_resp) => {
        if(_resp.data.Result === 'OK'){
            setRecord(_resp.data.Records)
        }
    }).catch((_resp) => {
        console.error(_resp)
    }).finally(() => {

    })
}

const groups = useMemo(() => {
    const map = new Map();
    for (const rec of records) {
        const pretty = formatDate(rec.meeting_date);
        if (!map.has(pretty)) {
        map.set(pretty, { key: rec.meeting_date, pretty, items: [] });
        }
        map.get(pretty).items.push(rec);
    }
    return Array.from(map.values());
}, [records]);

return (
<>
<PulledDownWrapper onRefresh={getMyMeetsUpComing}>
    <div className="max-w-[900px] gap-2 grid grid-cols-12">
        {groups.length > 0 ? (
            groups.map((group, gi) => (
                <div key={group.key} className="contents">
                    <div className="col-span-12">
                        <div className="text-center py-4 opacity-60">
                            {group.pretty}
                        </div>
                    </div>

                    {group.items.map((rec, ri) => {
                        const isLastGroup = gi === groups.length - 1;
                        const isLastCard = ri === group.items.length - 1;
                        const mb = isLastGroup && isLastCard ? "mb-40" : "mb-2";
                        return (
                            <div key={rec._id} className={`col-span-12 flex flex-col ${mb}`}>
                                <ActiveMeetingCard _record={rec} _onResp={null} />
                            </div>
                        );
                    })}
                </div>
            ))
        ) : (
            <div className="col-span-12 flex flex-col items-center justify-center py-12 text-center text-zinc-400">
                <CalendarCheck className="w-12 h-12 mb-2 opacity-50"/>
                <h2 className="text-lg font-medium">No Upcoming Meetings</h2>
                <p className="text-sm text-zinc-500">Patience is key 💅</p>
            </div>
        )}
    </div>
</PulledDownWrapper>
</>
);
}

export default UpComingMeetsComp